module.exports = __webpack_public_path__ + "static/img/icon-disk-iso.f8ebc39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icon-disk-iso.png
// module id = /mza
// module chunks = 35